/**
 * @copyright WaterStreet. All rights reserved.
 */

import {
	enableProdMode
} from '@angular/core';
import {
	platformBrowserDynamic
} from '@angular/platform-browser-dynamic';
import 'hammerjs';
import {
	AppModule
} from 'src/app/app.module';
import {
	environment
} from 'src/environments/environment';

if (environment.production)
{
	enableProdMode();
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch(err => console.log(err));
